import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {MetadataService} from '../../../../services/configuration/metadata.service';
import {EnumTranslator} from '../../../../Models/enum/enumTranslator';
import {MetadataType} from '../../../../Models/enum/metadataType';
import {Subject} from 'rxjs';
import {formatDate} from '@angular/common';
import {Utils} from '../../../../services/utils';

@Component({
  selector: 'app-edit-queue-metadata-modal',
  templateUrl: './edit-queue-metadata-modal.component.html',
  styleUrls: ['./edit-queue-metadata-modal.component.css']
})
export class EditQueueMetadataModalComponent implements OnInit {

  @Input() modalTitle;
  objInitialState;
  metadataForm: FormGroup;
  availableMetadata;
  metadataType = '';
  errorMessage;
  invalidMetadataValueError;
  invalidMetadataValue = false;
  itemSaved: Subject<any> = new Subject();
  metadataValue = '';
  metadataValueDate = '';
  oldStructure;

  get formData() { return this.metadataForm.controls; }

  get validFieldsType() {
    /*ng-disabled="(Metadata.Structure.Category == 1 && Metadata.Values.length == 1)
    || !Metadata.Structure || InvalidMetadataValue || !Metadata.Value"*/
    if (this.availableMetadata) {
      const raw = this.metadataForm.getRawValue();
      const metadataStructureId = raw.metadataStructureId;
      const values = raw.values;

      if (metadataStructureId !== null) {
        const item = this.availableMetadata.filter(f => f.metadataStructureId == parseFloat(metadataStructureId))[0];
        return (item.category == 1 && values.length == 1) || this.metadataType == '';
      }
    }
    return true;
  }

  get validTypeValue() {
    if (this.availableMetadata) {
      if (this.formData.metadataStructureId.value !== null &&
        (this.metadataValue !== undefined && this.metadataValue !== '') ||
        (this.metadataValueDate !== null)) {
        const metadataStructureId = this.formData.metadataStructureId.value;
        const item = this.availableMetadata.filter(f => f.metadataStructureId == parseFloat(metadataStructureId))[0];
        switch (item.type) {
          case 1: {
            this.invalidMetadataValue = !this.isInt(this.metadataValue);
            break;
          }
          case 2: {
            // this.invalidMetadataValue = !this.isValidDate(this.metadataValue);
            break;
          }
          case 3: { // texto
            this.metadataValue = this.metadataValue.trim();
            break;
          }
          case 4: {
            this.invalidMetadataValue = !this.isFloat(this.metadataValue);
            break;
          }
          default: {
            return false;
          }
        }
      }
      return this.invalidMetadataValue;
    }
    return false;
  }

  get validMinLengthArray() {
    return this.formData.values.value.length > 0;
  }

  constructor(public bsModalRef: BsModalRef, private formBuilder: FormBuilder, private metadataService: MetadataService) { }

  ngOnInit() {
    this.metadataValueDate = null; // formatDate(new Date(),'yyyy-MM-ddTHH:mm','pt-BR');
    this.createForm();
    this.getAllMetadata();
    if (this.objInitialState.metadataValues) {
      this.metadataForm.patchValue({
        metadataStructureId: this.objInitialState.metadataValues.structure.metadataStructureId,
        values: this.objInitialState.metadataValues.values
      });
    }
  }

  createForm() {
    this.metadataForm = this.formBuilder.group({
      metadataStructureId: [null, Validators.required],
      values: [[], Validators.required]
    });
  }

  getAllMetadata() {
    this.errorMessage = '';
    this.metadataService.getAllMetadataStructures().subscribe(res => {
      this.availableMetadata = res;
      if (this.objInitialState.metadataValues) {
        this.getMetadataType(this.objInitialState.metadataValues.structure.metadataStructureId, true);
        this.oldStructure = this.objInitialState.metadataValues.structure;
      }
      if (this.objInitialState.configuredMetadata) {
        this.availableMetadata = res.filter(f => this.objInitialState.configuredMetadata.indexOf(f.metadataStructureId) == -1);
      }
    }, error1 => {
      let err = error1;
      if (error1.indexOf('401') !== -1) {
        err = 'Erro: Sessão expirada.';
      }
      this.errorMessage = err;
    });
  }

  getMetadataType(item, onInit = false) {
    const type = this.availableMetadata.filter(f => f.metadataStructureId == parseFloat(item)).map(m => m.type);
    this.metadataType = EnumTranslator.getEnumMetadataType(MetadataType[type]);

    // ao mudar o metadado, devo limpar a lista
    if (!onInit) {
      this.invalidMetadataValueError = '';
      this.metadataValue = '';
      this.metadataValueDate = null;
      this.formData.values.setValue([]);
    }

  }

  addMetadataValue(metadataValue) {
    const values = this.formData.values.value;
    values.push(this.metadataType !== 'Data' ? metadataValue : Utils.formatDate(metadataValue, 'DD/MM/YYYY HH:mm'));
    this.formData.values.setValue(values);
    this.metadataValue = '';
    this.metadataValueDate = null;
  }

  removeMetadataValue(metadataValue) {
    this.formData.values.value.splice(this.formData.values.value.indexOf(metadataValue), 1);
    this.metadataForm.updateValueAndValidity();
  }

  onClickOk() {
    let raw = this.metadataForm.getRawValue();
    let result = {
      oldStructure: this.oldStructure,
      newStructure: this.availableMetadata.filter(f => f.metadataStructureId == raw.metadataStructureId)[0],
      values: raw.values
    };

    this.itemSaved.next(result);
    this.bsModalRef.hide();
  }

  onClose() {
    this.itemSaved.next(null);
    this.bsModalRef.hide();
  }

  cleanErrors() {
    this.invalidMetadataValue = false;
    this.invalidMetadataValueError = '';
  }

  validateMetadataText() {
    if (this.metadataType == 'Texto') {
      this.metadataValue = this.metadataValue.split(' ').filter(f => f !== '').join(' ');
    }
  }

  isValidDate(dateString) {
    var regEx = /^(([0-2]?[0-9])|(3[0-1]))(\/|-)((0?[1-9])|(1[0-2]))(\/|-)(\d{4})\s*((00|[0-9]|1[0-9]|2[0-3]):([0-9]|[0-5][0-9]):([0-9]|[0-5][0-9]))?$/;
    if (dateString.match(regEx) == null) {
      this.invalidMetadataValueError = 'Data inválida';
      return false;
    }

    return true;
  }

  isFloat(val) {
    var floatRegex = /^-?\d+(?:[,]\d*?)?$/;
    if (!floatRegex.test(val)) {
      this.invalidMetadataValueError = 'Ponto flutuante inválido';
      return false;
    }

    val = parseFloat(val);
    if (isNaN(val)) {
      this.invalidMetadataValueError = 'Ponto flutuante inválido';
      return false;
    }
    return true;
  }

  isInt(val) {
    var intRegex = /^-?\d+$/;
    if (!intRegex.test(val)) {
      this.invalidMetadataValueError = 'Número inteiro inválido';
      return false;
    }

    var intVal = parseInt(val, 10);
    if (parseFloat(val) == intVal && !isNaN(intVal)) {
      return true;
    } else {
      this.invalidMetadataValueError = 'Número inteiro inválido';
      return false;
    }
  }

  dateChanged(eventDate: string): Date | null {
    return !!eventDate ? new Date(eventDate) : null;
  }

  blockUserInput() {
    return false;
  }

}
